import React, { useContext, useEffect, useReducer, useState } from "react";
import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import { ToastMessageContext } from "lib/contexts/message_context";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { RecencyComplianceServices } from "lib/services/api/compliance/recency_compliance";
import AtasCovered from "views/Compliance/UserCompliance/UserDetails/AtasCovered";



const useStyles = makeStyles(theme => ({
    actionButtons: {
        position: 'absolute',
        marginTop: '-23px',
        textAlign: 'left',
        /* padding-left: 239px; */
        paddingLeft: '25px'
    }
}))

function Recency(props) {
    const classes = useStyles();
    const { title, id } = props;
    const [action, setAction] = useState(null);
    const message = useContext(ToastMessageContext);
    const [currentSelectedData, setCurrentSelectionData] = useState({});
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const tableOptions = {
        ...options,
        search: false,
        paging: false,
        pageSize: 5,
        toolbar: false
    };


    useEffect(() => {
        const params = {
            user_id: id
        }
        setLoading(true)
        RecencyComplianceServices.getRecencyListing(params).then((response) => {
            setData(response)
        }).catch(() => {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {
            setLoading(false)
        })

    }, [id]);

    const statusMapButtons = { "Green": "button-positive", "Amber": "button-warning", "Red": "button-negative" }
    const getStatusColor = (status) => {
        switch (status) {
            case "Green":
                return "#4FC605";
            case "Amber":
                return "#FFB300";
            case "Red":
                return "#FF0202";
            default:
                return "";
        }
    };
    const statusLabels = {
        Red: "Expired",
        Green: "Good",
        Amber: "Low",
    };


    const columns = [
        {
            title: "Name",
            field: "group_name",
            headerStyle: { textAlign: "left", paddingLeft: "15px" },
            cellStyle: { textAlign: "left", paddingLeft: "15px" },
        },

        {
            title: "Tasks in 2-Yrs",
            field: "task_count",
            render: (rowData) => (
                <span
                    style={{
                        color: getStatusColor(rowData.task_status),
                        fontWeight: 600,
                    }}
                >
                    {rowData.task_count ?? "-"}
                </span>
            ),
        },

        {
            title: "ATAs in 2-Yrs",
            field: "ata_count",
            render: (rowData) => (
                <div
                    onClick={() => {
                        setAction("atas_covered");
                        setCurrentSelectionData(rowData);
                    }}
                    style={{ cursor: "pointer" }}
                >
                    <span
                        style={{
                            color: getStatusColor(rowData.ata_status),
                            fontWeight: 600,
                            textDecoration: "underline",
                        }}
                    >
                        {rowData.ata_count ?? "-"}
                    </span>
                </div>
            ),
        },

        {
            title: "Status",
            field: "overall_status",
            render: (rowData) => {
                const status = rowData.overall_status;
                const label = statusLabels[status] || "-";
                return (
                    <Button
                        size="small"
                        variant="outlined"
                        className={status && statusMapButtons[status]}
                    >
                        <b>{label}</b>
                    </Button>
                );
            },
        },
    ];


    return (
        <div >
            <MaterialTable
                style={{
                    boxShadow: "0px 1px 3px #00000033",
                }}
                icons={tableIcons}
                title={<Typography variant="subtitle2" color="secondary">{title}</Typography>}
                columns={columns}
                data={data.data || []}
                isLoading={loading}
                options={tableOptions}
            />


            {action === "atas_covered" &&
                <AtasCovered currentSelection={currentSelectedData} open={action} handleClose={() => setAction(null)}
                />}
        </div>
    )
}

export default Recency;
